(function () {
    'use strict';
    var controllerId = 'tipologiaSelect';
    angular.module('app').controller(controllerId, ['$scope', '$rootScope', '$uibModalInstance', '$filter', 'datacontext', 'common', '_', 'generico', 'area', tipologiaSelectFn]);

    function tipologiaSelectFn($scope, $rootScope, $uibModalInstance, $filter, datacontext, common, _, generico, area) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');

        $scope.item = {};
        $scope.item.generico = generico;
        $scope.item.area = area;
        $scope.item.areeTecniche = [];
        $scope.item.tipologie = [];
        $scope.item.arrayChecked = [];
        $scope.item.AreaTecnicaId = null;
        $scope.enable = false;
        $scope.getTipologia = getTipologia;
        $scope.checkTipo = checkTipo;
        $scope.isAllSelected = false;

        $scope.NomeArea = area;
        switch (area) {
            case 'LINGUAGGI': $scope.NomeArea = 'Language';
                break;
            case 'NORME': $scope.NomeArea = 'Rule';
                break;
            case 'ATTIVITA': $scope.NomeArea = 'Activity';
                break;
        }

        if ($scope.item.generico)
            getTipologia();
        else {
            getAreeTecniche();
            if ($rootScope.AreaTecnicaId) {
                $scope.item.AreaTecnicaId = $rootScope.AreaTecnicaId;
                getTipologia();
            }    
        }

        function getTipologia() {
            switch (area) {
                case 'SOFTWARE': getTipoSoftware();
                    if (!$scope.item.generico)
                        $rootScope.AreaTecnicaId = $scope.item.AreaTecnicaId;
                    break;
                case 'LINGUAGGI': getTipoLinguaggi();
                    break;
                case 'NORME': getTipoNorme();
                    break;
                case 'STANDARD': getTipoStandard();
                    break;
                case 'ATTIVITA': getTipoAttivita();
                    $rootScope.AreaTecnicaId = $scope.item.AreaTecnicaId;
                    break;
            }
        }

        $scope.titolo = $scope.NomeArea + ' Typology';

        $scope.ok = function (isValid) {
            if (isValid) {
                var result = [];
                $scope.item.arrayChecked.forEach(function (item) {
                    var o = _.find($scope.item.tipologie, { 'Id': parseInt(item) });
                    var obj = {};
                    obj.Id = o.Id;
                    if (obj.Id == 0)
                        obj.TestoAltro = $scope.item.TestoAltro;
                    else
                        obj.TestoAltro = o.Name;
                    obj.AreaTecnicaId = $scope.item.AreaTecnicaId;
                    result.push(obj);
                });
                $uibModalInstance.close(result);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.toggleAll = function () {
            $scope.isAllSelected = !$scope.isAllSelected;
            $scope.item.arrayChecked = [];
            if ($scope.isAllSelected) {
                $("input:checkbox[name=tipoId]").each(function () {
                    if ($(this).val() != 0) {
                        this.checked = true;
                        $scope.item.arrayChecked.push($(this).val());
                    }
                });
            } else {
                $("input:checkbox[name=tipoId]").each(function () {
                    this.checked = false;
                    $scope.item.arrayChecked = [];
                    $scope.enable = false;
                });
            }
        };

        function checkTipo(item) {
            if (item.Name == 'Other')
                $scope.enable = !$scope.enable;

            $scope.item.arrayChecked = [];
            $("input:checkbox[name=tipoId]:checked").each(function () {
                $scope.item.arrayChecked.push($(this).val());
            });
        }

        function getTipoSoftware() {
            return datacontext.tipoSoftware_getAllByAreaTecnicaId($scope.item.AreaTecnicaId).then(function (data) {
                $scope.item.tipologie = [];
                if (data && data.length > 0) {
                    if ($scope.item.generico)
                        data.push({ Id: 0, Name: 'Other' });

                    return $scope.item.tipologie = data;
                }
            });
        }

        function getTipoLinguaggi() {
            return datacontext.tipoLinguaggio_getAllList().then(function (data) {
                $scope.item.tipologie = [];
                if (data && data.length > 0) {
                    data.push({ Id: 0, Name: 'Other' });
                    return $scope.item.tipologie = data;
                }
            });
        }

        function getTipoNorme() {
            return datacontext.tipoNorma_getAllList().then(function (data) {
                $scope.item.tipologie = [];
                if (data && data.length > 0) {
                    data.push({ Id: 0, Name: 'Other' });
                    return $scope.item.tipologie = data;
                }
            });
        }

        function getTipoStandard() {
            return datacontext.tipoStandard_getAllList().then(function (data) {
                $scope.item.tipologie = [];
                if (data && data.length > 0) {
                    data.push({ Id: 0, Name: 'Other' });
                    return $scope.item.tipologie = data;
                }
            });
        }

        function getTipoAttivita() {
            return datacontext.tipoAttivita_getAllByAreaTecnicaId($scope.item.AreaTecnicaId).then(function (data) {
                $scope.item.tipologie = [];
                if (data && data.length > 0) {
                    if ($scope.item.area == 'ATTIVITA' && $scope.item.AreaTecnicaId == 10)
                        data.push({ Id: 0, Name: 'Other' });
                    return $scope.item.tipologie = data;
                }
            });
        }

        function getAreeTecniche() {
            return datacontext.areaTecnica_getAllList().then(function (data) {
                 return $scope.item.areeTecniche = data;
            });
        }

        
    }
})();